import { render, staticRenderFns } from "./areaForm.vue?vue&type=template&id=a13569a2"
import script from "./areaForm.vue?vue&type=script&lang=js"
export * from "./areaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports